// Native dialog backdrops retarget events to the dialog itself. A click can
// therefore arrive there after a drag that started on text or a control.
export function initDialogBackdrop(dialog, close, { surface = () => dialog, enabled = () => true, isBackdrop = event => event.target === dialog } = {}) {
  let press = null;
  const outside = event => {
    const rect = surface()?.getBoundingClientRect();
    if (!rect) return false;
    return event.clientX < rect.left || event.clientX > rect.right
      || event.clientY < rect.top || event.clientY > rect.bottom;
  };
  const down = event => {
    if (event.isPrimary === false) return;
    press = enabled() && event.button === 0 ? { id: event.pointerId, outside: outside(event), releasedOutside: false } : null;
  };
  const up = event => {
    if (press && press.id === event.pointerId) press.releasedOutside = outside(event);
  };
  const cancel = event => {
    if (press?.id === event.pointerId) press = null;
  };
  const click = event => {
    const dismiss = enabled() && press?.outside && press.releasedOutside && event.button === 0
      && isBackdrop(event) && outside(event)
      && (event.pointerId === undefined || event.pointerId === press.id);
    press = null;
    if (dismiss) close();
  };
  dialog.addEventListener('pointerdown', down, true);
  dialog.addEventListener('pointerup', up, true);
  dialog.addEventListener('pointercancel', cancel, true);
  dialog.addEventListener('click', click);
  return () => {
    press = null;
    dialog.removeEventListener('pointerdown', down, true);
    dialog.removeEventListener('pointerup', up, true);
    dialog.removeEventListener('pointercancel', cancel, true);
    dialog.removeEventListener('click', click);
  };
}
